import { useNavigate } from 'react-router-dom'
import {
  CALCULATE_SAFE_HARBOR_STEP,
  useCalculateSafeHarborSteps,
} from './helpers'
import { Card, Image, Text, CardColors } from '@/ui'
import {
  TaxProfileAccordions,
  useTaxProfileAccordionCopy,
} from '@/features/taxes/taxes-profile/form-flow/TaxProfileAccordions'
import { CalculateSafeHarborFooter } from './CalculateSafeHarborFooter'
import { useReselector } from '@/utils/sharedHooks'
import { selectIsCurrentUserScorp } from '@/selectors/user.selectors'
import { TypographyStyles } from '@/styles'
//TODO: Migrate to v2
import { QuarterlyTaxEstimateDetail } from '@/featuresV1/Admin/QuarterlyTaxEstimateDetails/quarterlyTaxEstimateDetails.slice'

export const CalculateSafeHarborIntro = ({
  details,
}: {
  details?: QuarterlyTaxEstimateDetail | null
}) => {
  const navigate = useNavigate()
  const { goToNextStep } = useCalculateSafeHarborSteps(
    CALCULATE_SAFE_HARBOR_STEP.calculateSafeHarborIntro
  )
  const isScorp = useReselector(selectIsCurrentUserScorp)

  const faqCopy = useTaxProfileAccordionCopy()

  return (
    <div className="space-y-6">
      <Image
        src="https://heard-images.s3.amazonaws.com/assets/practice.png"
        className=" flex justify-center h-[180px] w-[180px]"
        alt="Practice"
      />

      <Text
        className="max-w-3xl mx-auto text-center"
        variant={TypographyStyles.DISPLAY_LG}
      >
        Let&apos;s get ready for your estimate
      </Text>

      <div className="max-w-3xl mx-auto">
        <Card color={CardColors.LEVEL_1}>
          <Text variant={TypographyStyles.H2}>You’ll need:</Text>
          <Text>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>
                Your <b>1040</b> Individual Tax Return for{' '}
                <b>{Number(details?.taxYear) - 1}</b>
              </li>
              <li>
                If applicable, any estimated tax payment vouchers that have been
                provided to you
              </li>
            </ul>
            <br />
            This should take about <b>5-10 minutes.</b>
          </Text>
        </Card>
      </div>

      <TaxProfileAccordions
        faqs={[
          faqCopy.whoPaysQtes,
          faqCopy.no1040TaxReturn,
          faqCopy.noPayQtesPriorQuarters,
          ...(isScorp ? [faqCopy.haveToPayQTEsScorp] : []),
        ]}
      />

      <CalculateSafeHarborFooter
        submitOrContinue={() => goToNextStep()}
        goToPreviousStep={() => navigate('/taxes/quarterly')}
      />
    </div>
  )
}
